import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import getFirstAccessibleRoute from '../../helpers/getFirstAccessibleRoute';

const AccessDenied = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { user } = useAuth();

    return (
        <Box
            style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '2rem',
            }}
        >
            <Typography variant="h6">{t('common.accessDenied')}</Typography>
            <Button variant="contained" onClick={() => navigate(getFirstAccessibleRoute(user))}>
                {t('common.backToHome')}
            </Button>
        </Box>
    );
};

export default AccessDenied;
